import { render, staticRenderFns } from "./ReportTables.vue?vue&type=template&id=2e74c220&scoped=true"
import script from "./ReportTables.vue?vue&type=script&lang=js"
export * from "./ReportTables.vue?vue&type=script&lang=js"
import style0 from "./ReportTables.vue?vue&type=style&index=0&id=2e74c220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74c220",
  null
  
)

export default component.exports